<div *ngIf="isShow" class="big-photo-overlay">
  <img class="big-photo-image" [src]="case.imageUrl"  alt="Big Photo"/>
  <i class="pi pi-times big-photo-close" (click)="closeBigPhoto()"></i>
</div>
